module.exports = __webpack_public_path__ + "media/images/emblems/HUNDW_F-cc96580a281bf7216d4d29c439e7b4a0.png";